var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "jss16660 jss16661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.97 19.822-3.52-3.52a8.828 8.828 0 0 0 1.94-5.53c0-4.89-3.97-8.86-8.86-8.86-4.89 0-8.86 3.97-8.86 8.86 0 4.89 3.97 8.86 8.86 8.86 2.01 0 3.96-.68 5.53-1.94l3.52 3.52a.99.99 0 0 0 1.39 0c.38-.38.38-1 0-1.39zm-7.49-8.06H8.57c-.54 0-.98-.44-.98-.98s.44-.98.98-.98h5.91c.54 0 .98.44.98.98s-.44.98-.98.98z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default __webpack_public_path__ + "static/media/zoomOut.25c00bf9d5b9e9d5df44f00727ad30e1.svg";
export { ForwardRef as ReactComponent };